import { useState } from 'react';
import ConfirmationDialog from '@/components/confirmation-dialog';

interface Props<T> {
  title?: string;
  message: string;
  action?: string;
  isLoading?: boolean;
  dispatcher: (payload?: T) => void;
  onSuccess?: () => void;
}

const useConfirmation = <T,>({
  title,
  message,
  action,
  isLoading,
  dispatcher,
  onSuccess
}: Props<T>) => {
  const [isOpen, setIsOpen] = useState(false);
  const [actionPayload, setActionPayload] = useState<T>();

  const openDialog = () => {
    setIsOpen(true);
  };

  const closeDialog = () => {
    setIsOpen(false);
  };

  const confirmAction = (payload: T) => {
    openDialog();

    setActionPayload(payload);
  };

  const onSubmit = () => {
    if (!actionPayload) return;

    try {
      dispatcher(actionPayload);
      onSuccess?.()
    } catch (error) {
      console.error(error);
    }
    closeDialog();
  };

  const renderConfirmationDialog = () => (
    <ConfirmationDialog
      isOpen={isOpen}
      title={title}
      action={action}
      message={message}
      isLoading={isLoading}
      onSubmit={onSubmit}
      onClose={closeDialog}
    />
  );

  return [renderConfirmationDialog, confirmAction];
};

export default useConfirmation;
